import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px 0 20px;
  position: relative;
  display: flex;
  min-width: 0;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  gap: 30px;
`;
